import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const Button = styled.div`
  cursor: pointer;
  position: absolute;
  right: 0;
  margin: 20px 20px 0 0;
`;

const Icon = styled.i`
  font-size: 36px;
  font-weight: 36px;
`;

const ClearButton = ({ onClick }) => (
  <Button onClick={onClick}>
    <Icon className="material-icons">close</Icon>
  </Button>
);

ClearButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default ClearButton;



// WEBPACK FOOTER //
// ./src/components/CoachPanel/CloseButton.jsx